import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";

let isInitialized = false;
let currentToken: string | null = null;

type RegisterFn = (token: string, platform: "ios" | "android" | "web") => void;

/**
 * Initialize push notifications on native platforms (iOS/Android).
 * Should be called after user login.
 */
export async function initPushNotifications(onRegister: RegisterFn) {
  if (isInitialized) return;
  if (!Capacitor.isNativePlatform()) return;

  const platform = Capacitor.getPlatform() as "ios" | "android" | "web";
  if (platform !== "ios" && platform !== "android") return;

  // Request permission
  const permResult = await PushNotifications.requestPermissions();
  if (permResult.receive !== "granted") {
    console.log("[Push] Permission not granted");
    return;
  }

  // Register for push
  await PushNotifications.register();

  // Token received
  PushNotifications.addListener("registration", (token) => {
    console.log("[Push] Token received:", token.value.substring(0, 20) + "...");
    currentToken = token.value;
    onRegister(token.value, platform);
  });

  // Registration error
  PushNotifications.addListener("registrationError", (err) => {
    console.error("[Push] Registration error:", err);
  });

  // Notification received while app is in foreground
  PushNotifications.addListener("pushNotificationReceived", (notification) => {
    console.log("[Push] Foreground notification:", notification.title);
    // Foreground notifications are handled by the app's own UI
  });

  // Notification tapped (app opened from notification)
  PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
    const data = action.notification.data;
    console.log("[Push] Notification tapped, data:", data);

    // Navigate based on notification data
    if (data?.url) {
      window.location.href = data.url;
    }
  });

  isInitialized = true;
}

/**
 * Get the current push token (if registered)
 */
export function getPushToken(): string | null {
  return currentToken;
}

/**
 * Check if running as a native app
 */
export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}
